export enum EnumTipoConfig {
    Texto = 1,
    Numero = 2,
    ButtonValidar = 3,
    ButtonRedirecionar = 4
}